import { createAddressObj, createAddressObj_  } from "./address";


const ret_file_desc = (files)=> files.map(cert=>({_id: cert._id, name: cert.file?.name || '', size: cert.file?.size || 0, type: cert.file?.mime}));


const getBenefit = (benefit) =>{

const benetit_obj = {
      type: '',
      documentType: '',
      documentNumber: '',
      issuedTo: '',
      issueDate: '',
      isApproved: false,
      files: [],
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      }
};

if(!benefit || benefit.length < 1) return benetit_obj;

const ben = benefit[0];

if(!ben || !ben.benefitId) return benetit_obj;

benetit_obj.type = ben.benefitId;
benetit_obj.documentType = ben.documentType;
benetit_obj.documentNumber = ben.documentNumber;
benetit_obj.issuedTo = ben.documentTo;
benetit_obj.issueDate = ben.documentIssueDate;
//benetit_obj.address = createAddressObj_(ben.address);
benetit_obj.files = ret_file_desc(ben.benScan);
benetit_obj.isApproved = ben.isApproved;


if(ben.brothers){
    benetit_obj.kindergarten = ben.brothers.kg?._id;
    benetit_obj.siblingName = ben.brothers.name;
    benetit_obj.siblingBirthCertificate = ben.brothers.bcert;
    benetit_obj.siblingBirthDate = ben.brothers.bdate;
}

if(ben.personal){
    benetit_obj.kindergarten = ben.personal.kg?._id;
    benetit_obj.employeeName = ben.personal.name;
    benetit_obj.employeeRnokpp = ben.personal.ipn;
    
}

if(ben.benefitId == "60e81561904ae40729056dc4"){
    benetit_obj.kindergarten = ben.kindergartenId;
    benetit_obj.address = createAddressObj_(ben.address);
}



return benetit_obj;

};



export function convertReqToForm(req){


    const { _id, child, responsiblePerson, dissabilities, neededPlaceDescription, dictionary, criterias, youngerGroup, invite, languageTraining } = req;

    const { benefits } = child;

    const ben = benefits[0] || {};


    let _dictionary = {};


    try{

        _dictionary = JSON.parse(dictionary)
    
    } catch(err){
        console.log('error parse. dictionary: ', dictionary);
    }


    const getCertCountry = (txt)=>{
        if(["Україна", "ua"].includes(txt)) return "ua";
        return "other"
    }

    const getGender = (txt)=>{
        if(["boy", "чол"].includes(txt)) return "boy";
        if(["girl", "жін"].includes(txt)) return "girl";
        return "";
    }

    return(
        {    
            _id,
            child: {
                lastName: child.lastName,
                firstName: child.firstName,
                secondName: child.secondName,
                birthDate: child.birthDate,
                gender: getGender(child.gender),
                birthCertificate: {
                    seriesNumber: child.birthCertificate.number,
                    issueDate: child.birthCertificate.issueDate,
                    country: getCertCountry(child.birthCertificate.issueCountry),
                    files: ret_file_desc(child.certScan)
                },
                addressYur: createAddressObj_(child.addressDictYur),
                addressFact: createAddressObj_(child.addressDictFact),
                sameFactAddress: child.sameFactAddress ? "yes" : "no",
                address: child.address,
                isAddressKyiv: child.isAddressKyiv ? "yes" : "no",
                addressFactStr: child.addressFact,
                notFindKyivAddress: child.indicators?.notFindKyivAddress === true || child.indicators?.notFindKyivAddress === "true" ? true : false
                },
            applicant: {
                lastName: responsiblePerson.lastName,
                firstName: responsiblePerson.firstName,
                middleName: responsiblePerson.seconName,
                citizenship: responsiblePerson.citizenship || 'Україна',
                rnokpp: responsiblePerson.code,
                phone: responsiblePerson.contacts.phone,
                email: responsiblePerson.contacts.email,
                address: createAddressObj_(responsiblePerson.addressDict),
                addressStr: responsiblePerson.address,
                documentType: responsiblePerson.typeOfDoc,
                documentDetails: responsiblePerson.documentDetails || '',
                hasRnokpp: responsiblePerson.typeOfDoc && responsiblePerson.typeOfDoc == "code" ? "yes": "no",
                isAddressKyiv: responsiblePerson.isAddressKyiv ? "yes" : "no",
                notFindKyivAddress: responsiblePerson.indicators?.notFindKyivAddress === true || responsiblePerson.indicators?.notFindKyivAddress === "true" ? true : false
            },
            // Додайте до об'єкту preferences в функції convertReqToForm:
            preferences: {
                desiredDate: req.preferDateFrom,
                languageTraining: languageTraining || 'uk',
                inclusiveGroup: neededPlaceDescription.inclusive,
                withoutBed: neededPlaceDescription.notWithoutFullDay || false,      // Додати
                notWithoutBed: neededPlaceDescription.notWithoutBed || false, // Додати
                dissabilities: dissabilities.specializationId || false, 
                diseaseType: dissabilities.specializationId,
                diseaseDocument: {
                    type: dissabilities.typeOfDoc,
                    number: dissabilities.medicalProtocol,
                    issuedTo: dissabilities.issueTo,
                    issueDate: dissabilities.dateFrom,
                    files: ret_file_desc(dissabilities.docScan)
                },
                ageMenu: youngerGroup
            },
            benefits: getBenefit(benefits),
            selectedSchools: criterias && criterias[0] && criterias[0].values && criterias[0].values || [],
            agreePersonalData: "yes",
            dictionary: _dictionary,
            invite
        }
    )
}